import { Box, Button, Stack, Typography } from '@mui/material';

type FallbackScreenProps = {
  onReload: () => void;
};

export function FallbackScreen({ onReload }: FallbackScreenProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px={2}
    >
      <Stack spacing={2} alignItems="center" textAlign="center" maxWidth={420}>
        <Typography variant="h5" component="h1">
          Algo deu errado
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Ocorreu um erro inesperado na aplicação. Nossa equipe já foi
          notificada. Tente recarregar a página.
        </Typography>
        <Button variant="contained" onClick={onReload}>
          Recarregar página
        </Button>
      </Stack>
    </Box>
  );
}
